import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { DataServiceService } from 'src/app/core/helpers/data-service.service';

@Component({
    selector: 'loyaltic-upload-receipt',
    templateUrl: './upload-receipt.component.html',
    styleUrls: ['./upload-receipt.component.scss'],
    standalone: false
})
export class UploadReceiptComponent implements OnInit {
  receipt: any;
  Quantity = 1;
  receiptSrc: any;
  ReceiptName = '';
  culture = ''

  showConfirmReceiptUploadPopUp = false;
  @Output() receiptUploadSuccess = new EventEmitter<any>();

  constructor(private authService: AuthService, private coreService: CoreService,
    private toast: ToastrService, private translate: TranslateService, private router: Router,
    private dataService: DataServiceService) {
    this.culture = translate.getDefaultLang();
  }

  ngOnInit() {
  }

  // onReceiptSelect(event) {
  //   this.receipt = event.target.files[0];
  // }
  onReceiptSelect(event) {
    this.receipt = event.target.files[0];
    this.ReceiptName = this.receipt.name;
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (e: any) => {
        const img = document.createElement('img');
        img.src = e.target.result;
        this.receiptSrc = e.target.result;
      };
    }
  }
  onReceiptUpload(form) {
    const userId = this.authService.getUserId();
    const body = {
      UserId: userId,
      Quantity: 1,
      File: this.receipt
    };

    const formData = new FormData();
    formData.append('UserId', userId);
    formData.append('Quantity', this.Quantity.toString());
    formData.append('File', this.receipt);

    this.coreService.upLoadReceipt(formData).then((res: any) => {
      form.submitted = false;
      this.resetForm();
      this.toast.success(this.translate.instant('' + res.messageKey), this.translate.instant('success'));
      this.receiptUploadSuccess.emit(res.result);
      if (!res.result.isapproved && res.result.recptPartitionKey && res.result.recptRowKey) {
        this.dataService.setReceiptNotApprovedData(res.result)
        this.showConfirmReceiptUploadPopUp = true;
        return;
      }
    }).catch((errorResponse: any) => {
      // this.resetForm();
      const errorMessage = this.translate.instant(errorResponse.error.messageKey);
      this.toast.error(errorMessage, 'Error');
      return;
    });
  }

  resetForm() {
    this.ReceiptName = '';
    this.Quantity = undefined;
    this.receipt = undefined;
  }
}
